/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable indent */
/* eslint-disable unicorn/prefer-module */
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { ListadoFacturas, Header, BuildingDetailsModal } from "../../components";
import { EDIFICIOS_EXCLUIDOS } from "../../constants/permisos";
import { useAuthContext } from "../../context/auth";
import {
  getEdificiosOperativos,
  getFacturasComision2,
  getFacturasComisionTodos,
  getIntermediarios,
  getClientes,
  getOportunidadesBTL,
  getContratos,
  log,
  calcularImporteNetoIntermediario,
  calcularPorcentajeComisionIntermediario,
  obtenerNombreIntermediario,
  getConvertedImporte,
  calcularPantallasAjustadas,
  calcularComisionEdificiosTotal,
  explodarContratosComoFacturas,
  esEdificioComisionFija,
} from "../../utils";
import { getRateForOpp } from "../../utils/calculateVentas";
import { getSaldoEdificio } from "../../utils/getSaldoEdificio";
import { client } from "../../utils/supabase";
import { useExchangeRates } from "../../utils/useExchangeRates";
import "./stylesCalculadorComisionEdificio.scss";

const regexFecha = /^(20\d{2})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
const MESES_NOMBRE = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("safari") && !ua.includes("chrome");
};

export const CalculadorComisionEdificio = () => {
  // const [edificios, setEdificios] = useState([]);
  const [facturas, setFacturas] = useState(null);
  const [todosEdificios, setTodosEdificios] = useState([]);
  // Operativos SIN filtrar por edificiosOk: el modal de detalle muestra todas las filas de la
  // venta (pantallas/inversión de todos los edificios), aunque %/costo se recorten por edificio.
  const [edificiosFull, setEdificiosFull] = useState([]);
  const [selectedSale, setSelectedSale] = useState(null);
  const [intermediarios, setIntermediarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [investmentType, setInvestmentType] = useState("todas");
  const [activeTab, setActiveTab] = useState("variable");
  const [vistaActiva, setVistaActiva] = useState("comision");
  const [isLoading, setIsLoading] = useState(false);
  const [pagosEdificio, setPagosEdificio] = useState([]);
  const [totalesListado, setTotalesListado] = useState({
    bruto: null,
    neto: null,
    comisionIntermediario: null,
    generada: null,
    recaudada: null,
    pendiente: null,
  });
  const [historico, setHistorico] = useState({
    bruto: null,
    neto: null,
    comisionIntermediario: null,
    generada: null,
    recaudada: null,
    loading: false,
  });
  // Referencia estable para evitar loop infinito en ListadoFacturas (useEffect deps).
  const handleTotalesCalculados = useCallback((t) => setTotalesListado(t), []);
  const lastFormValues = useRef({ edificio: "0", fechaInicio: "", fechaFin: "", investmentType: "todas" });
  const { pais, edificiosOk, rol } = useAuthContext() || {};
  const isDemoMode = rol === "edificio" && (!edificiosOk || edificiosOk.length === 0);
  const { getDolarValue, dolarFallback, loaded: ratesLoaded } = useExchangeRates(pais);

  const { handleSubmit, register, watch } = useForm({ defaultValues: { edificio: "0" } });
  const [edificioSeleccionado, fechaInicio, fechaFin] = watch(["edificio", "fechaInicio", "fechaFin"]);

  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
      })[pais] || "es-UY",
    []
  );

  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$ ",
        Perú: "S/ ",
        Uruguay: "$ ",
      })[pais] || "$ ",
    []
  );

  const decimales = useCallback(
    (pais) =>
      ({
        Chile: 0,
        Perú: 2,
        Uruguay: 0,
      })[pais] || 0,
    []
  );

  // Map completo de operativos (id → edificio) para el modal de detalle. Usa edificiosFull
  // (sin filtrar por edificiosOk) para que el desglose muestre TODAS las filas de la venta.
  const edificiosMapModal = useMemo(
    () =>
      edificiosFull.reduce((acc, e) => {
        if (e.id) acc[e.id] = e;
        return acc;
      }, {}),
    [edificiosFull]
  );

  // getRate por venta para el modal (misma cascada que el listado: facturafecha → fecha_cierre → …).
  const getRateModal = useCallback(
    (opp) => getRateForOpp(opp, getDolarValue, dolarFallback[pais]),
    [getDolarValue, dolarFallback, pais]
  );

  // Datos para tab Fijos: comisiones fijas mensuales por edificio
  const datosFijos = useMemo(() => {
    if (
      !fechaInicio ||
      !fechaFin ||
      todosEdificios.length === 0 ||
      !regexFecha.test(fechaInicio) ||
      !regexFecha.test(fechaFin)
    ) {
      return null;
    }

    // Determinar qué edificios mostrar
    let edificiosGrupo = [];
    const esIndividual =
      edificioSeleccionado !== "0" &&
      edificioSeleccionado !== "todos" &&
      !todosEdificios.some((ed) => ed.alianza === edificioSeleccionado);

    if (edificioSeleccionado === "todos") {
      edificiosGrupo = todosEdificios;
    } else if (todosEdificios.some((ed) => ed.alianza === edificioSeleccionado)) {
      edificiosGrupo = todosEdificios.filter((ed) => ed.alianza === edificioSeleccionado);
    } else {
      const ed = todosEdificios.find((e) => e.id === Number(edificioSeleccionado));
      if (ed) edificiosGrupo = [ed];
    }

    // Filtrar a edificios con comisión fija
    const edificiosFijos = edificiosGrupo.filter((ed) => ed.comision_fija_monto > 0 && ed.comision_fija_inicio);
    if (edificiosFijos.length === 0) return { edificiosFijos: [], esIndividual, filas: [], resumen: [] };

    // Generar rango de meses (parseo manual para evitar bug timezone UTC vs local)
    const [sY, sM] = fechaInicio.split("-").map(Number);
    const [eY, eM] = fechaFin.split("-").map(Number);
    const meses = [];
    let curY = sY,
      curM = sM;
    while (curY < eY || (curY === eY && curM <= eM)) {
      meses.push({ year: curY, month: curM, fechaPrimero: `${curY}-${String(curM).padStart(2, "0")}-01` });
      curM++;
      if (curM > 12) {
        curM = 1;
        curY++;
      }
    }

    if (esIndividual && edificiosFijos.length === 1) {
      // Edificio individual: detalle mensual
      const ed = edificiosFijos[0];
      const montoUSD = Number(ed.comision_fija_monto);
      const filas = meses
        .filter((mes) => esEdificioComisionFija(ed, mes.fechaPrimero))
        .map((mes) => {
          const tc = getDolarValue(mes.fechaPrimero);
          return { periodo: `${MESES_NOMBRE[mes.month - 1]} ${mes.year}`, montoUSD, tc, montoLocal: montoUSD * tc };
        });
      return { edificiosFijos, esIndividual: true, filas, resumen: [] };
    }

    // Alianza/Todos: resumen por edificio
    const resumen = edificiosFijos.map((ed) => {
      const montoUSD = Number(ed.comision_fija_monto);
      const mesesActivos = meses.filter((m) => esEdificioComisionFija(ed, m.fechaPrimero));
      let totalLocal = 0;
      mesesActivos.forEach((m) => {
        totalLocal += montoUSD * getDolarValue(m.fechaPrimero);
      });
      return {
        edificio: ed.edificio,
        montoMensualUSD: montoUSD,
        cantMeses: mesesActivos.length,
        totalUSD: montoUSD * mesesActivos.length,
        totalLocal,
      };
    });
    return { edificiosFijos, esIndividual: false, filas: [], resumen };
  }, [edificioSeleccionado, fechaInicio, fechaFin, todosEdificios, getDolarValue, pais]);

  useEffect(() => {
    if (isDemoMode) return;
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const [intermediariosData, clientesData] = await Promise.all([getIntermediarios(), getClientes({ pais })]);

        // NORMALIZAR TIPOS PARA EVITAR BUGS DE STRING VS NUMBER
        const intermediariosNormalizados = (intermediariosData || []).map((i) => ({
          ...i,
          id: Number(i.id),
        }));

        const clientesNormalizados = (clientesData || []).map((c) => ({
          ...c,
          id: Number(c.id),
          agencia: c.agencia ? String(c.agencia).trim() : null,
        }));

        setIntermediarios(intermediariosNormalizados);
        setClientes(clientesNormalizados);
      } catch (error) {
        console.error("fetchData error:", error);
        toast.error(`Error al cargar datos iniciales: ${error.message || "Error desconocido"}`);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [pais, isDemoMode]);

  // const calcularPantallasAjustadas = (edificio, factura) => {
  //   const { pantallas_ascensores, pantallas_espera, pantallas_circulacion, pantallas_cowork } = factura;
  //   const edificioId = edificio.id.toString();

  //   if (!pantallas_ascensores && !pantallas_espera && !pantallas_circulacion && !pantallas_cowork) {
  //     return (edificio.pantallas || 0) + (edificio.espera || 0) + (edificio.totems || 0) + (edificio.cowork || 0);
  //   }

  //   let totalPantallas = 0;
  //   if (pantallas_ascensores && pantallas_ascensores.split(",").includes(edificioId)) {
  //     totalPantallas += edificio.pantallas || 0;
  //   }
  //   if (pantallas_espera && pantallas_espera.split(",").includes(edificioId)) {
  //     totalPantallas += edificio.espera || 0;
  //   }
  //   if (pantallas_circulacion && pantallas_circulacion.split(",").includes(edificioId)) {
  //     totalPantallas += edificio.totems || 0;
  //   }
  //   if (pantallas_cowork && pantallas_cowork.split(",").includes(edificioId)) {
  //     totalPantallas += edificio.cowork || 0;
  //   }
  //   return totalPantallas;
  // };

  const onSubmit = useCallback(
    async (data) => {
      setIsLoading(true);
      try {
        setFacturas(null);
        let listaFacturas = [];
        let ventasBTL = [];

        const fechaInicioDate = new Date(data.fechaInicio);
        const fechaFinDate = new Date(data.fechaFin);
        if (isNaN(fechaInicioDate) || isNaN(fechaFinDate)) {
          throw new Error("Fechas inválidas");
        }

        const anoInicio = fechaInicioDate.getFullYear();
        const anoFin = fechaFinDate.getFullYear();
        const anos = [...new Set([anoInicio, anoFin])];
        const btlPromises = anos.map((ano) => getOportunidadesBTL({ pais, ano }).catch(() => []));
        const btlResults = await Promise.all(btlPromises);
        const btlData = btlResults.flat();

        const uniqueBTLSales = new Map();
        btlData
          .filter((sale) => {
            const facturaFecha = new Date(sale.facturafecha);
            const isValidDate = !isNaN(facturaFecha.getTime());
            if (!isValidDate) return false;
            const buildings = sale.buildings
              ? typeof sale.buildings === "string"
                ? JSON.parse(sale.buildings)
                : sale.buildings
              : [];
            const edificioIds = buildings.map((b) => b.id);
            return (
              sale.pais === pais &&
              !sale.eliminada &&
              facturaFecha >= fechaInicioDate &&
              facturaFecha <= fechaFinDate &&
              (data.edificio === "todos" ||
                edificioIds.includes(Number(data.edificio)) ||
                todosEdificios.some((ed) => ed.alianza === data.edificio && edificioIds.includes(ed.id)))
            );
          })
          .forEach((sale) => {
            if (!uniqueBTLSales.has(sale.id)) {
              const buildings = sale.buildings
                ? typeof sale.buildings === "string"
                  ? JSON.parse(sale.buildings)
                  : sale.buildings
                : [];
              const edificioData = buildings.find((b) => b.id === Number(data.edificio)) || buildings[0];
              const cliente = clientes.find((c) => c.id === sale.client_id && c.pais === pais);
              const clienteNombre = cliente ? cliente.nombre : "SIN CLIENTE";
              uniqueBTLSales.set(sale.id, {
                id: sale.id,
                facturanumero: sale.facturanumero || "-",
                facturafecha: sale.facturafecha,
                facturafechacobro: sale.facturafechacobro,
                cliente: clienteNombre,
                importe: edificioData ? edificioData.importe : 0,
                comision: edificioData ? edificioData.comision : 0,
                edificiosUnicos: buildings.length,
                pantallastotales: 0,
                isBTL: true,
                client_id: sale.client_id,
                buildings,
              });
            }
          });
        ventasBTL = [...uniqueBTLSales.values()];

        if (investmentType === "solo-btl" && ventasBTL.length === 0) {
          toast.error("No hay ventas BTL para los criterios seleccionados.");
        }

        const btlContributions = new Map();
        if (investmentType !== "solo-pauta") {
          ventasBTL.forEach((sale) => {
            const rateBTL = getRateForOpp(sale, getDolarValue, dolarFallback[pais]);
            sale.buildings.forEach((building) => {
              const edificioId = building.id;
              if (!btlContributions.has(edificioId)) {
                btlContributions.set(edificioId, { totalFacturadoBTL: 0, netoFacturadoBTL: 0, comisionGeneradaBTL: 0 });
              }
              const contrib = btlContributions.get(edificioId);
              const importeLocal = sale.moneda_dolar ? building.importe * rateBTL : building.importe;
              contrib.totalFacturadoBTL += importeLocal;
              contrib.netoFacturadoBTL += importeLocal;
              const edificio = todosEdificios.find((e) => e.id === edificioId);
              if (edificio) {
                const edificiosMapTemp = { [edificioId]: edificio };
                let comisionBTL = calcularComisionEdificiosTotal(sale, edificiosMapTemp, importeLocal);
                if (sale.moneda_dolar) comisionBTL = comisionBTL * rateBTL;
                contrib.comisionGeneradaBTL += comisionBTL;
              }
            });
          });
        }

        // Cargar contratos y explotar meses en facturas
        const edificiosMap = todosEdificios.reduce((acc, e) => {
          if (e.id) acc[e.id] = e;
          return acc;
        }, {});
        let facturasContratos = [];
        if (investmentType !== "solo-btl") {
          const contratosData = await getContratos({ pais }).catch(() => []);
          facturasContratos = explodarContratosComoFacturas(
            contratosData,
            edificiosMap,
            data.fechaInicio,
            data.fechaFin
          );
        }

        // Helper: calcula resumen de comisiones para un grupo de edificios (usado en modo "todos" y "alianza")
        const calcularResumenEdificios = async (edificiosGrupo) => {
          let facturasList = [];
          if (investmentType !== "solo-btl") {
            facturasList = await getFacturasComisionTodos({
              edificios: edificiosGrupo.map((ed) => ed.id),
              fechas: [data.fechaInicio, data.fechaFin],
              pais,
            });
            facturasList = facturasList.map((f) => ({ ...f, isBTL: false }));
            facturasList = [...facturasList, ...facturasContratos];
          }

          if (facturasList.length === 0 && btlContributions.size === 0) {
            return [];
          }

          return edificiosGrupo
            .map((edificio) => {
              const facturasEdificio =
                investmentType !== "solo-btl"
                  ? facturasList.filter((factura) =>
                      factura.edificiosparticipantes?.split(",").includes(edificio.id.toString())
                    )
                  : [];

              const totalFacturadoFacturas = facturasEdificio.reduce((total, factura) => {
                const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);
                const proporcionPantallas =
                  factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;
                const rateFactura = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                const importeFactura = getConvertedImporte(factura, rateFactura);
                return total + proporcionPantallas * importeFactura;
              }, 0);

              const netoFacturadoFacturas = facturasEdificio.reduce((total, factura) => {
                const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);
                const proporcionPantallas =
                  factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;
                const neto = calcularImporteNetoIntermediario(factura, clientes, intermediarios, pais);
                const rateNeto = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                const netoConvertido = factura.moneda_dolar ? neto * rateNeto : neto;
                return total + proporcionPantallas * netoConvertido;
              }, 0);

              const comisionGeneradaFacturas = facturasEdificio.reduce((total, factura) => {
                const netoFactura = calcularImporteNetoIntermediario(factura, clientes, intermediarios, pais);
                const edificiosMapTemp = { [edificio.id]: edificio };
                const comisionFactura = calcularComisionEdificiosTotal(factura, edificiosMapTemp, netoFactura);
                const rateComision = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                const comisionConvertida = factura.moneda_dolar ? comisionFactura * rateComision : comisionFactura;
                return total + comisionConvertida;
              }, 0);

              const btlContrib = btlContributions.get(edificio.id) || {
                totalFacturadoBTL: 0,
                netoFacturadoBTL: 0,
                comisionGeneradaBTL: 0,
              };

              const comisionRecaudadaFacturas = facturasEdificio.reduce((total, factura) => {
                if (!factura.facturafechacobro) return total;
                const netoFactura = calcularImporteNetoIntermediario(factura, clientes, intermediarios, pais);
                const edificiosMapTemp = { [edificio.id]: edificio };
                const comisionFactura = calcularComisionEdificiosTotal(factura, edificiosMapTemp, netoFactura);
                const rateComision = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                return total + (factura.moneda_dolar ? comisionFactura * rateComision : comisionFactura);
              }, 0);

              const comisionRecaudadaBTL = ventasBTL
                .filter((s) => s.facturafechacobro && (s.buildings || []).some((b) => b.id === edificio.id))
                .reduce((t, s) => {
                  const building = (s.buildings || []).find((b) => b.id === edificio.id);
                  if (!building) return t;
                  const rateBTL = getRateForOpp(s, getDolarValue, dolarFallback[pais]);
                  const importeLocal = s.moneda_dolar ? building.importe * rateBTL : building.importe;
                  const edificiosMapTemp = { [edificio.id]: edificio };
                  let comBTL = calcularComisionEdificiosTotal(s, edificiosMapTemp, importeLocal);
                  if (s.moneda_dolar) comBTL *= rateBTL;
                  return t + comBTL;
                }, 0);

              return {
                edificioId: edificio.id,
                edificio: edificio.edificio,
                totalFacturado: totalFacturadoFacturas + btlContrib.totalFacturadoBTL,
                netoFacturado: netoFacturadoFacturas + btlContrib.netoFacturadoBTL,
                comisionGenerada: comisionGeneradaFacturas + btlContrib.comisionGeneradaBTL,
                comisionRecaudada: comisionRecaudadaFacturas + comisionRecaudadaBTL,
              };
            })
            .filter(
              (resumen) => resumen.totalFacturado > 0 || resumen.netoFacturado > 0 || resumen.comisionGenerada > 0
            );
        };

        if (data.edificio === "todos") {
          setFacturas(await calcularResumenEdificios(todosEdificios));
        } else if (todosEdificios.some((edificio) => edificio.alianza === data.edificio)) {
          const edificiosAlianza = todosEdificios.filter((edificio) => edificio.alianza === data.edificio);
          setFacturas(await calcularResumenEdificios(edificiosAlianza));
        } else {
          const edificio = todosEdificios.find((ed) => ed.id === Number(data.edificio));
          if (!edificio) {
            setFacturas([]);
            return;
          }

          if (investmentType !== "solo-btl") {
            listaFacturas = await getFacturasComision2({
              edificio: data.edificio,
              fechas: [data.fechaInicio, data.fechaFin],
              pais,
            });

            listaFacturas = listaFacturas.map((factura) => {
              const importeNetoTotal = calcularImporteNetoIntermediario(factura, clientes, intermediarios, pais);
              const comisionPorcentaje = calcularPorcentajeComisionIntermediario(
                factura,
                clientes,
                intermediarios,
                pais
              );
              const intermediarioNombre = obtenerNombreIntermediario(factura, clientes, intermediarios, pais);

              // Cálculo de pantallas ajustadas del edificio actual
              const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);

              // Participación del edificio en esta factura
              const participacion = factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;

              // Neto proporcional al edificio (esto es lo que queremos mostrar)
              const importeNetoProporcional = participacion * importeNetoTotal;

              // Convertir USD → moneda local si corresponde
              const rate = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
              const importeNetoFinal = factura.moneda_dolar ? importeNetoProporcional * rate : importeNetoProporcional;
              const importeBrutoFinal = factura.moneda_dolar ? factura.importe * rate : factura.importe;

              return {
                ...factura,
                intermediario: intermediarioNombre,
                comision: comisionPorcentaje,
                importeNeto: importeNetoFinal,
                importe: importeBrutoFinal,
                isBTL: false,
                // Venta CRUDA preservada para el modal de detalle (importe bruto + moneda_dolar
                // originales). El modal re-deriva neto/comisión para TODOS los edificios.
                __rawSale: factura,
              };
            });

            // Agregar facturas de contratos filtradas por este edificio
            const contratosEdificio = facturasContratos
              .filter((f) => f.edificiosparticipantes?.split(",").includes(String(data.edificio)))
              .map((factura) => {
                const importeNetoTotal = calcularImporteNetoIntermediario(factura, clientes, intermediarios, pais);
                const comisionPorcentaje = calcularPorcentajeComisionIntermediario(
                  factura,
                  clientes,
                  intermediarios,
                  pais
                );
                const intermediarioNombre = obtenerNombreIntermediario(factura, clientes, intermediarios, pais);
                const clienteRef = clientes.find((c) => c.id === factura.client_id && c.pais === pais);
                const clienteNombre = clienteRef
                  ? clienteRef.empresa === clienteRef.producto
                    ? clienteRef.nombre
                    : `${clienteRef.empresa} | ${clienteRef.producto}`
                  : "SIN CLIENTE";
                const pantallasAjustadas = calcularPantallasAjustadas(edificio, factura);
                const proporcion = factura.pantallastotales > 0 ? pantallasAjustadas / factura.pantallastotales : 0;
                const importeNetoProporcional = proporcion * importeNetoTotal;

                // Convertir USD → moneda local si corresponde
                const rateContrato = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                const netoFinal = factura.moneda_dolar
                  ? importeNetoProporcional * rateContrato
                  : importeNetoProporcional;
                const brutoFinal = factura.moneda_dolar ? factura.importe * rateContrato : factura.importe;

                return {
                  ...factura,
                  cliente: clienteNombre,
                  intermediario: intermediarioNombre,
                  comision: comisionPorcentaje,
                  importeNeto: netoFinal,
                  importe: brutoFinal,
                  isBTL: false,
                  // Contrato-factura CRUDO preservado para el modal de detalle (ver nota arriba).
                  __rawSale: factura,
                };
              });
            listaFacturas = [...listaFacturas, ...contratosEdificio];
          } else {
            listaFacturas = [];
          }

          const btlFiltradasSet = new Set();
          const btlFiltradas =
            investmentType !== "solo-pauta"
              ? ventasBTL.filter((sale) => {
                  const isRelevant = (sale.buildings || []).some((b) => b.id === Number(data.edificio));
                  if (isRelevant && !btlFiltradasSet.has(sale.id)) {
                    btlFiltradasSet.add(sale.id);
                    return true;
                  }
                  return false;
                })
              : [];

          const combinedListado = [
            ...(investmentType !== "solo-btl" ? listaFacturas : []),
            ...(investmentType !== "solo-pauta" ? btlFiltradas : []),
          ];

          if (combinedListado.length === 0) {
            setFacturas([]);
            return;
          }

          const newFacturas = {
            comisionEdificio_1_porcentaje: edificio.comision_1_porcentaje,
            comisionEdificio_1_fechainicio: edificio.comision_1_fechainicio,
            comisionEdificio_1_fechafin: edificio.comision_1_fechafin,
            comisionEdificio_2_porcentaje: edificio.comision_2_porcentaje,
            comisionEdificio_2_fechainicio: edificio.comision_2_fechainicio,
            comisionEdificio_2_fechafin: edificio.comision_2_fechafin,
            comisionEdificio_3_porcentaje: edificio.comision_3_porcentaje,
            comisionEdificio_3_fechainicio: edificio.comision_3_fechainicio,
            comisionEdificio_3_fechafin: edificio.comision_3_fechafin,
            listado: combinedListado,
            pantallasEdificio: edificio.pantallas + edificio.totems + edificio.espera + edificio.cowork,
            edificioId: edificio.id,
          };
          setFacturas(newFacturas);
        }
      } catch (error) {
        log.error("CalculadorComisionEdificio", error);
        toast.error(`Error al procesar el informe: ${error.message}`);
        setFacturas([]);
      } finally {
        setIsLoading(false);
      }
    },
    [todosEdificios, intermediarios, pais, clientes, investmentType, getDolarValue, dolarFallback]
  );

  const forceSubmit = useCallback(() => {
    if (intermediarios.length === 0 || clientes.length === 0 || todosEdificios.length === 0) {
      return;
    }
    handleSubmit(onSubmit)();
  }, [handleSubmit, onSubmit, intermediarios, clientes, todosEdificios]);

  useEffect(() => {
    if (isDemoMode) return;
    const initialize = async () => {
      setIsLoading(true);
      try {
        const newEdificios = await getEdificiosOperativos({ pais });
        newEdificios.sort((a, b) => a.edificio.localeCompare(b.edificio));
        const edificiosFiltrados = newEdificios.filter((ed) => !EDIFICIOS_EXCLUIDOS.includes(ed.id));
        setEdificiosFull(edificiosFiltrados);
        const todos = !edificiosOk
          ? edificiosFiltrados
          : edificiosFiltrados.filter((edificio) => edificiosOk.includes(edificio.id));
        setTodosEdificios(todos);
      } catch (error) {
        toast.error(`Error al inicializar edificios: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
    initialize();
  }, [pais, edificiosOk, isDemoMode]);

  useEffect(() => {
    const currentFormValues = { edificio: edificioSeleccionado, fechaInicio, fechaFin, investmentType };
    const hasChanged = JSON.stringify(currentFormValues) !== JSON.stringify(lastFormValues.current);
    if (
      edificioSeleccionado !== "0" &&
      regexFecha.test(fechaInicio) &&
      regexFecha.test(fechaFin) &&
      intermediarios.length > 0 &&
      clientes.length > 0 &&
      todosEdificios.length > 0 &&
      ratesLoaded &&
      hasChanged &&
      !isLoading
    ) {
      lastFormValues.current = currentFormValues;
      forceSubmit();
    }
  }, [
    forceSubmit,
    edificioSeleccionado,
    fechaInicio,
    fechaFin,
    investmentType,
    intermediarios,
    clientes,
    todosEdificios,
    isLoading,
    ratesLoaded,
  ]);

  // Pagos al edificio (movimientos_caja con categoria_pago='comision_edificio') — histórico completo.
  // No se filtra por fecha porque el saldo a pagar es acumulado (cuenta corriente continua del edificio).
  useEffect(() => {
    if (
      !pais ||
      !edificioSeleccionado ||
      edificioSeleccionado === "0" ||
      !regexFecha.test(fechaInicio) ||
      !regexFecha.test(fechaFin) ||
      todosEdificios.length === 0
    ) {
      setPagosEdificio([]);
      return;
    }

    const resolverIds = () => {
      if (edificioSeleccionado === "todos") return todosEdificios.map((e) => e.id);
      if (todosEdificios.some((e) => e.alianza === edificioSeleccionado))
        return todosEdificios.filter((e) => e.alianza === edificioSeleccionado).map((e) => e.id);
      return [Number(edificioSeleccionado)];
    };

    const ids = resolverIds();
    if (ids.length === 0) {
      setPagosEdificio([]);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const { data } = await client
          .from("movimientos_caja")
          .select("id, fecha, monto, entidad_id, descripcion")
          .eq("pais", pais)
          .eq("entidad_tipo", "edificio")
          .eq("categoria_pago", "comision_edificio")
          .neq("estado", "anulado")
          .in("entidad_id", ids);
        if (!cancelled) setPagosEdificio(data || []);
      } catch {
        if (!cancelled) setPagosEdificio([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [pais, edificioSeleccionado, fechaInicio, fechaFin, todosEdificios]);

  // Histórico no bloqueante: corre en paralelo al onSubmit, dispara cuando cambia edificio o pais.
  // Solo modo individual por ahora. Reusa la pipeline de cálculo de comisión sin filtro de fechas.
  useEffect(() => {
    if (
      !pais ||
      !edificioSeleccionado ||
      edificioSeleccionado === "0" ||
      todosEdificios.length === 0 ||
      intermediarios.length === 0 ||
      clientes.length === 0 ||
      !ratesLoaded
    ) {
      setHistorico({
        bruto: null,
        neto: null,
        comisionIntermediario: null,
        generada: null,
        recaudada: null,
        loading: false,
      });
      return;
    }

    const esIndividual =
      edificioSeleccionado !== "todos" && !todosEdificios.some((e) => e.alianza === edificioSeleccionado);
    if (!esIndividual) return;

    const edificio = todosEdificios.find((e) => e.id === Number(edificioSeleccionado));
    if (!edificio) return;

    setHistorico((prev) => ({ ...prev, loading: true }));

    let cancelled = false;
    (async () => {
      try {
        // Fuente única de verdad: motor extraído a getSaldoEdificio. Mismo cálculo que antes vivía
        // inline acá (generada/recaudada históricas [2023-01-01 … hoy]). El saldo a pagar se sigue
        // derivando en el render como recaudada − pagada (pagadaHistorico de pagosEdificio).
        const r = await getSaldoEdificio({ pais, edificioId: edificio.id });

        if (!cancelled) {
          setHistorico({
            bruto: r.bruto,
            neto: r.neto,
            comisionIntermediario: r.comisionIntermediario,
            generada: r.generada,
            recaudada: r.recaudada,
            loading: false,
          });
        }
      } catch (err) {
        console.error("[historico] error:", err);
        if (!cancelled) setHistorico((prev) => ({ ...prev, loading: false }));
      }
    })();
    return () => {
      cancelled = true;
    };
    // getDolarValue y dolarFallback se capturan por closure y son referencias inestables
    // (no memoizadas en useExchangeRates). Incluirlas en deps causa re-render loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edificioSeleccionado, pais, todosEdificios, intermediarios, clientes, ratesLoaded]);

  const demoMoneda = pais === "Perú" ? "S/ " : "$ ";
  const demoLocale = pais === "Perú" ? "es-PE" : "es-CL";
  const demoDecimales = pais === "Perú" ? 2 : 0;
  const demoEquipo = pais === "Perú" ? "Visiona" : "Wecast";
  const fmt = (n) =>
    `${demoMoneda}${n.toLocaleString(demoLocale, {
      minimumFractionDigits: demoDecimales,
      maximumFractionDigits: demoDecimales,
    })}`;

  if (isDemoMode) {
    const mul = pais === "Perú" ? 1 : 1000;
    const demoConsolidado = [
      {
        edificio: "Edificio A",
        totalFacturado: 28500 * mul,
        netoFacturado: 24225 * mul,
        comisionGenerada: 3634 * mul,
      },
      {
        edificio: "Edificio B",
        totalFacturado: 19200 * mul,
        netoFacturado: 16320 * mul,
        comisionGenerada: 2448 * mul,
      },
      {
        edificio: "Edificio C",
        totalFacturado: 12800 * mul,
        netoFacturado: 10880 * mul,
        comisionGenerada: 1632 * mul,
      },
    ];

    const totalBruto = demoConsolidado.reduce((t, r) => t + r.totalFacturado, 0);
    const totalNeto = demoConsolidado.reduce((t, r) => t + r.netoFacturado, 0);
    const totalComision = demoConsolidado.reduce((t, r) => t + r.comisionGenerada, 0);

    const demoFacturas = [
      {
        tipo: "PAUTA",
        numero: "F-2025-0412",
        fecha: "15/01/25",
        cliente: "Cliente Ejemplo 1",
        pantallas: 42,
        share: "28.6%",
        bruto: 12000 * mul,
        intermediario: "DIRECTO",
        comPct: "-",
        neto: 12000 * mul,
        comEdPct: "15%",
        comEd: 1800 * mul,
        cobrada: true,
      },
      {
        tipo: "PAUTA",
        numero: "F-2025-0455",
        fecha: "01/02/25",
        cliente: "Cliente Ejemplo 2",
        pantallas: 42,
        share: "28.6%",
        bruto: 9500 * mul,
        intermediario: "Agencia Demo",
        comPct: "15%",
        neto: 8075 * mul,
        comEdPct: "15%",
        comEd: 1211 * mul,
        cobrada: true,
      },
      {
        tipo: "BTL",
        numero: "BTL-2025-018",
        fecha: "20/02/25",
        cliente: "Cliente Ejemplo 3",
        pantallas: "-",
        share: "-",
        bruto: 3500 * mul,
        intermediario: "DIRECTO",
        comPct: "-",
        neto: 3500 * mul,
        comEdPct: "15%",
        comEd: 525 * mul,
        cobrada: false,
      },
      {
        tipo: "PAUTA",
        numero: "F-2025-0501",
        fecha: "10/03/25",
        cliente: "Cliente Ejemplo 1",
        pantallas: 42,
        share: "28.6%",
        bruto: 3500 * mul,
        intermediario: "DIRECTO",
        comPct: "-",
        neto: 3500 * mul,
        comEdPct: "15%",
        comEd: 525 * mul,
        cobrada: false,
      },
    ];

    const totalDetBruto = demoFacturas.reduce((t, f) => t + (typeof f.bruto === "number" ? f.bruto : 0), 0);
    const totalDetNeto = demoFacturas.reduce((t, f) => t + (typeof f.neto === "number" ? f.neto : 0), 0);
    const totalDetCom = demoFacturas.reduce((t, f) => t + (typeof f.comEd === "number" ? f.comEd : 0), 0);

    return (
      <div className="CalculadorComisionEdificio">
        <Header />

        <div
          style={{
            background: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: 8,
            padding: "16px 24px",
            margin: "20px 0",
            fontSize: "0.95rem",
          }}
        >
          <strong>Usted no tiene edificios asignados.</strong> Por favor contacte al equipo {demoEquipo} para su
          vinculación.
        </div>

        <div style={{ opacity: 0.85 }}>
          <p style={{ marginTop: 20, marginBottom: 16, fontSize: "0.95rem" }}>
            A continuación le compartimos una vista consolidada como ejemplo de cómo se liquidan las comisiones.
          </p>
          <h5 style={{ marginBottom: 12 }}>Vista Consolidada (ejemplo)</h5>
          <table className="table table-success table-bordered table-custom table-totales">
            <thead>
              <tr className="total-row">
                <td className="text-start">TOTALES</td>
                <td className="text-end">{fmt(totalBruto)}</td>
                <td className="text-end">{fmt(totalNeto)}</td>
                <td className="text-end">{fmt(totalComision)}</td>
                <td className="text-center">100%</td>
              </tr>
            </thead>
          </table>
          <table className="table table-striped table-bordered table-hover table-custom table-detalles">
            <thead className="text-center align-middle">
              <tr>
                <th width="5%">#</th>
                <th width="25%">EDIFICIO</th>
                <th width="20%">FACTURACIÓN BRUTA</th>
                <th width="20%">FACTURACIÓN NETA</th>
                <th width="20%">COMISIÓN GENERADA</th>
                <th width="10%">%</th>
              </tr>
            </thead>
            <tbody>
              {demoConsolidado.map((r, i) => (
                <tr key={r.edificio}>
                  <td className="text-center">{i + 1}</td>
                  <td className="text-start uppercase">{r.edificio}</td>
                  <td className="text-end">{fmt(r.totalFacturado)}</td>
                  <td className="text-end">{fmt(r.netoFacturado)}</td>
                  <td className="text-end">{fmt(r.comisionGenerada)}</td>
                  <td className="text-center">{((r.comisionGenerada / totalComision) * 100).toFixed(1)}%</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h5 style={{ marginTop: 32, marginBottom: 12 }}>Vista Detalle por Edificio (ejemplo — Edificio A)</h5>
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover table-custom">
              <thead className="text-center align-middle" style={{ background: "#343a40", color: "#fff" }}>
                <tr>
                  <th>TIPO</th>
                  <th>NRO FACTURA</th>
                  <th>FECHA FACTURA</th>
                  <th>CLIENTE</th>
                  <th>PANTALLAS</th>
                  <th>SHARE EDIFICIO</th>
                  <th>IMPORTE BRUTO</th>
                  <th>INTERMEDIARIO</th>
                  <th>COMISIÓN</th>
                  <th>IMPORTE NETO</th>
                  <th>COM. EDIFICIO %</th>
                  <th>COM. EDIFICIO $</th>
                  <th>COBRADA</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "0.8rem" }}>
                {demoFacturas.map((f) => (
                  <tr key={f.numero}>
                    <td className="text-center">{f.tipo}</td>
                    <td className="text-center">{f.numero}</td>
                    <td className="text-center">{f.fecha}</td>
                    <td>{f.cliente}</td>
                    <td className="text-center">{f.pantallas}</td>
                    <td className="text-center">{f.share}</td>
                    <td className="text-end">{fmt(f.bruto)}</td>
                    <td>{f.intermediario}</td>
                    <td className="text-center">{f.comPct}</td>
                    <td className="text-end">{fmt(f.neto)}</td>
                    <td className="text-center">{f.comEdPct}</td>
                    <td className="text-end">{fmt(f.comEd)}</td>
                    <td className="text-center">
                      <span style={{ color: f.cobrada ? "green" : "red", fontWeight: 600 }}>
                        {f.cobrada ? "Sí" : "Pendiente"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot style={{ background: "#343a40", color: "#fff", fontWeight: 600, fontSize: "0.8rem" }}>
                <tr>
                  <td colSpan="6" className="text-start">
                    TOTALES
                  </td>
                  <td className="text-end">{fmt(totalDetBruto)}</td>
                  <td colSpan="2" />
                  <td className="text-end">{fmt(totalDetNeto)}</td>
                  <td />
                  <td className="text-end">{fmt(totalDetCom)}</td>
                  <td />
                </tr>
              </tfoot>
            </table>
          </div>

          <p style={{ fontStyle: "italic", color: "#666", marginTop: 16, fontSize: "0.85rem" }}>
            Los datos mostrados son ejemplos ilustrativos. Una vez asignados sus edificios, verá la información real de
            facturación y comisiones.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="CalculadorComisionEdificio">
      {isLoading ? (
        <p>Cargando datos...</p>
      ) : isSafari() ? (
        <div className="safari-warning">
          <p>
            Este componente solo es compatible con Google Chrome. Por favor, utiliza Chrome para acceder a esta
            funcionalidad.
          </p>
        </div>
      ) : intermediarios.length === 0 || clientes.length === 0 ? (
        <p>Error: No se pudieron cargar los datos necesarios.</p>
      ) : (
        <>
          <Header
            leftContent={
              <div style={{ display: "flex", alignItems: "center", marginLeft: 150 }}>
                <div
                  style={{
                    display: "flex",
                    gap: 0,
                    borderRadius: 6,
                    overflow: "hidden",
                    border: "1px solid #dee2e6",
                  }}
                >
                  {[
                    { key: "comision", label: "Comisión" },
                    { key: "eecc", label: "EECC" },
                  ].map((v) => (
                    <button
                      key={v.key}
                      type="button"
                      onClick={() => setVistaActiva(v.key)}
                      style={{
                        padding: "6px 22px",
                        fontSize: "0.82rem",
                        fontWeight: 600,
                        border: "none",
                        cursor: "pointer",
                        background: vistaActiva === v.key ? "#2c3e50" : "transparent",
                        color: vistaActiva === v.key ? "#fff" : "#666",
                      }}
                    >
                      {v.label}
                    </button>
                  ))}
                </div>
              </div>
            }
          >
            <form className="filtros-container" onSubmit={handleSubmit(onSubmit)}>
              <div className="filtro-group">
                <label>1. Edificio o Alianza</label>
                <select className="form-select" {...register("edificio")}>
                  <option disabled value="0">
                    Selecciona una opción
                  </option>
                  {todosEdificios.length > 1 && <option value="todos">Todos</option>}
                  {[...new Set(todosEdificios.map((edificio) => edificio.alianza))]
                    .filter((alianza) => alianza)
                    .map((alianza) => (
                      <option key={alianza} value={alianza}>
                        {alianza}
                      </option>
                    ))}
                  {todosEdificios.map((edificio) => (
                    <option key={edificio.id} value={edificio.id}>
                      {edificio.edificio}
                    </option>
                  ))}
                </select>
              </div>
              <div className="filtro-group">
                <label>2. Fecha de Inicio</label>
                <input type="date" className="form-control" {...register("fechaInicio")} />
              </div>
              <div className="filtro-group">
                <label>3. Fecha de Fin</label>
                <input type="date" className="form-control" {...register("fechaFin")} />
              </div>
              <div className="filtro-group">
                <label>4. Tipo de Inversión</label>
                <select
                  className="form-select"
                  value={investmentType}
                  onChange={(e) => setInvestmentType(e.target.value)}
                >
                  <option value="todas">Todas las Inversiones</option>
                  <option value="solo-pauta">Pauta publicitaria</option>
                  <option value="solo-btl">BTL</option>
                </select>
              </div>
            </form>
          </Header>

          {/* Banda: aviso de cifras dinámicas (no definitivas hasta la liquidación) */}
          <div
            style={{
              background: "#fff3cd",
              border: "1px solid #ffe69c",
              borderRadius: 6,
              padding: "10px 18px",
              margin: "16px 0 4px",
              fontSize: "0.82rem",
              color: "#664d03",
              textAlign: "center",
            }}
          >
            Estos montos reflejan el estado actual de las ventas y pueden registrar modificaciones, producto de
            revisiones o ajustes, hasta el momento de su liquidación.
          </div>

          {/* Tabs Variable / Fijos */}
          {pais === "Perú" && edificioSeleccionado !== "0" && fechaInicio && fechaFin && (
            <div style={{ display: "flex", gap: 0, margin: "12px 0 16px" }}>
              <button
                className={`btn ${activeTab === "variable" ? "btn-primary" : "btn-outline-secondary"}`}
                onClick={() => setActiveTab("variable")}
                style={{ borderRadius: "6px 0 0 6px" }}
              >
                Variable
              </button>
              <button
                className={`btn ${activeTab === "fijos" ? "btn-primary" : "btn-outline-secondary"}`}
                onClick={() => setActiveTab("fijos")}
                style={{ borderRadius: "0 6px 6px 0" }}
              >
                Fijos
              </button>
            </div>
          )}

          {/* ═══ BARRA KPIs ═══ */}
          {facturas &&
            (Array.isArray(facturas) ? facturas.length > 0 : facturas.listado?.length > 0) &&
            (() => {
              const fmtKpi = (n) =>
                n == null ? "—" : `${moneda(pais)}${Math.round(n).toLocaleString(localString(pais))}`;
              const pagadaHistorico = pagosEdificio.reduce((s, p) => s + Number(p.monto || 0), 0);
              const labelRecaudada = pais === "Chile" ? "Recaudada" : "Cobrada";

              const gridStyle = {
                display: "grid",
                gridTemplateColumns: "repeat(7, 1fr)",
                gap: 16,
                width: "90%",
                margin: "16px auto",
                padding: "14px 0",
              };
              const labelStyle = {
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: 5,
                paddingBottom: 5,
                borderBottom: "1px solid rgba(255,255,255,0.3)",
                opacity: 0.9,
                textTransform: "uppercase",
              };
              const valueStyle = { fontSize: "1.05rem", fontWeight: 700, marginTop: 5 };
              const headerSubtitleStyle = {
                gridColumn: "1 / -1",
                fontSize: "0.7rem",
                color: "#888",
                marginBottom: 2,
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              };
              const renderCard = (kpi, valueOverride) => (
                <div
                  key={kpi.label}
                  style={{
                    background: kpi.bg || "#343a40",
                    borderRadius: 6,
                    padding: "12px 24px",
                    textAlign: "center",
                    color: "#fff",
                    opacity: kpi.dim ? 0.5 : 1,
                  }}
                >
                  <div style={labelStyle}>{kpi.label}</div>
                  <div style={valueStyle}>{valueOverride ?? fmtKpi(kpi.valor)}</div>
                </div>
              );

              if (vistaActiva === "eecc") {
                const saldoEecc = historico.recaudada != null ? historico.recaudada - pagadaHistorico : null;
                const kpisEecc = [
                  { label: "Facturación Bruta", valor: historico.bruto },
                  { label: "Intermediación", valor: historico.comisionIntermediario },
                  { label: "Facturación Neta", valor: historico.neto },
                  { label: "Com. Generada", valor: historico.generada },
                  { label: labelRecaudada, valor: historico.recaudada, bg: "#198754" },
                  { label: "Pagada", valor: pagadaHistorico },
                  {
                    label: "Saldo a Pagar",
                    valor: saldoEecc,
                    bg: saldoEecc != null && saldoEecc < 0 ? "#722f37" : "#343a40",
                  },
                ];
                return (
                  <div style={gridStyle}>
                    <div style={headerSubtitleStyle}>Estado de cuenta histórico — desde 2023 a hoy</div>
                    {kpisEecc.map((kpi) =>
                      renderCard({ ...kpi, dim: historico.loading }, historico.loading ? "..." : undefined)
                    )}
                  </div>
                );
              }

              // Vista "comision" — KPIs del período
              const esGrupo = Array.isArray(facturas);
              const bruto = esGrupo ? facturas.reduce((s, r) => s + r.totalFacturado, 0) : totalesListado.bruto;
              const neto = esGrupo ? facturas.reduce((s, r) => s + r.netoFacturado, 0) : totalesListado.neto;
              const intermediario = esGrupo
                ? bruto != null && neto != null
                  ? bruto - neto
                  : null
                : totalesListado.comisionIntermediario;
              const generada = esGrupo ? facturas.reduce((s, r) => s + r.comisionGenerada, 0) : totalesListado.generada;
              const recaudada = esGrupo
                ? facturas.reduce((s, r) => s + (r.comisionRecaudada || 0), 0)
                : totalesListado.recaudada;
              const pagadaPeriodo = pagosEdificio
                .filter((p) => p.fecha >= fechaInicio && p.fecha <= fechaFin)
                .reduce((s, p) => s + Number(p.monto || 0), 0);
              // Vista "Comisión" = todo período: saldo = recaudada del período − pagada del período
              // (la vista "EECC" usa histórico vía getSaldoEdificio, no se toca).
              const saldo = recaudada != null ? recaudada - pagadaPeriodo : null;

              const kpis = [
                { label: "Facturación Bruta", valor: bruto },
                { label: "Intermediación", valor: intermediario },
                { label: "Facturación Neta", valor: neto },
                { label: "Comisión Generada", valor: generada },
                { label: labelRecaudada, valor: recaudada, bg: "#198754" },
                { label: "Pagada (período)", valor: pagadaPeriodo },
                {
                  label: "Saldo a Pagar",
                  valor: saldo,
                  bg: saldo != null && saldo < 0 ? "#722f37" : "#343a40",
                },
              ];

              return (
                <div style={gridStyle}>
                  <div style={headerSubtitleStyle}>Comisión del período seleccionado</div>
                  {kpis.map((kpi) => renderCard(kpi))}
                </div>
              );
            })()}

          {/* ═══ TAB FIJOS ═══ */}
          {pais === "Perú" && activeTab === "fijos" && datosFijos && (
            <div>
              {datosFijos.edificiosFijos.length === 0 ? (
                <p style={{ fontStyle: "italic", color: "#888", marginTop: 8 }}>
                  {datosFijos.esIndividual
                    ? "Este edificio no tiene comisión fija configurada."
                    : "No hay edificios con comisión fija en este grupo."}
                </p>
              ) : datosFijos.esIndividual ? (
                /* Edificio individual: detalle mensual */
                <div>
                  <h6 style={{ marginBottom: 12, color: "#555" }}>
                    Comisión Fija: ${datosFijos.edificiosFijos[0]?.comision_fija_monto} USD/mes desde{" "}
                    {new Date(datosFijos.edificiosFijos[0]?.comision_fija_inicio).toLocaleDateString("es-PE")}
                  </h6>
                  <table className="table table-striped table-bordered table-hover table-custom table-detalles">
                    <thead className="text-center align-middle">
                      <tr>
                        <th width="25%">PERÍODO</th>
                        <th width="25%">MONTO USD</th>
                        <th width="25%">TC (1ro del mes)</th>
                        <th width="25%">MONTO LOCAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datosFijos.filas.map((fila) => (
                        <tr key={fila.periodo}>
                          <td className="text-center">{fila.periodo}</td>
                          <td className="text-end">{`$ ${fila.montoUSD.toFixed(2)}`}</td>
                          <td className="text-center">{fila.tc.toFixed(2)}</td>
                          <td className="text-end">
                            {`${moneda(pais)}${Math.round(fila.montoLocal).toLocaleString(localString(pais), {
                              minimumFractionDigits: decimales(pais),
                              maximumFractionDigits: decimales(pais),
                            })}`}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    {datosFijos.filas.length > 0 && (
                      <tfoot>
                        <tr className="table-dark">
                          <td className="text-center">
                            <strong>TOTAL</strong>
                          </td>
                          <td className="text-end">
                            <strong>{`$ ${datosFijos.filas.reduce((s, f) => s + f.montoUSD, 0).toFixed(2)}`}</strong>
                          </td>
                          <td className="text-center">—</td>
                          <td className="text-end">
                            <strong>
                              {`${moneda(pais)}${Math.round(
                                datosFijos.filas.reduce((s, f) => s + f.montoLocal, 0)
                              ).toLocaleString(localString(pais), {
                                minimumFractionDigits: decimales(pais),
                                maximumFractionDigits: decimales(pais),
                              })}`}
                            </strong>
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              ) : (
                /* Alianza/Todos: resumen por edificio */
                <div>
                  {/* Totales */}
                  <table className="table table-success table-bordered table-custom table-totales">
                    <thead>
                      <tr className="total-row">
                        <td className="text-start">TOTALES COMISIÓN FIJA</td>
                        <td className="text-end">
                          {`$ ${datosFijos.resumen
                            .reduce((s, r) => s + r.totalUSD, 0)
                            .toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                        </td>
                        <td className="text-end">
                          {`${moneda(pais)}${Math.round(
                            datosFijos.resumen.reduce((s, r) => s + r.totalLocal, 0)
                          ).toLocaleString(localString(pais), {
                            minimumFractionDigits: decimales(pais),
                            maximumFractionDigits: decimales(pais),
                          })}`}
                        </td>
                        <td className="text-center">100%</td>
                      </tr>
                    </thead>
                  </table>
                  {/* Detalle por edificio */}
                  <table className="table table-striped table-bordered table-hover table-custom table-detalles">
                    <thead className="text-center align-middle">
                      <tr>
                        <th width="5%">#</th>
                        <th width="25%">EDIFICIO</th>
                        <th width="15%">USD/MES</th>
                        <th width="10%">MESES</th>
                        <th width="20%">TOTAL USD</th>
                        <th width="25%">TOTAL LOCAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datosFijos.resumen.map((r, i) => (
                        <tr key={r.edificio}>
                          <td className="text-center">{i + 1}</td>
                          <td className="text-start uppercase">{r.edificio}</td>
                          <td className="text-end">{`$ ${r.montoMensualUSD.toFixed(2)}`}</td>
                          <td className="text-center">{r.cantMeses}</td>
                          <td className="text-end">
                            {`$ ${r.totalUSD.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                          </td>
                          <td className="text-end">
                            {`${moneda(pais)}${Math.round(r.totalLocal).toLocaleString(localString(pais), {
                              minimumFractionDigits: decimales(pais),
                              maximumFractionDigits: decimales(pais),
                            })}`}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* ═══ TAB VARIABLE ═══ */}
          {/* CASO EDIFICIO INDIVIDUAL → ListadoFacturas */}
          {activeTab === "variable" && facturas?.listado?.length > 0 ? (
            <ListadoFacturas
              facturas={facturas.listado}
              comisionEdificio_1_porcentaje={facturas.comisionEdificio_1_porcentaje}
              comisionEdificio_1_fechainicio={facturas.comisionEdificio_1_fechainicio}
              comisionEdificio_1_fechafin={facturas.comisionEdificio_1_fechafin}
              comisionEdificio_2_porcentaje={facturas.comisionEdificio_2_porcentaje}
              comisionEdificio_2_fechainicio={facturas.comisionEdificio_2_fechainicio}
              comisionEdificio_2_fechafin={facturas.comisionEdificio_2_fechafin}
              comisionEdificio_3_porcentaje={facturas.comisionEdificio_3_porcentaje}
              comisionEdificio_3_fechainicio={facturas.comisionEdificio_3_fechainicio}
              comisionEdificio_3_fechafin={facturas.comisionEdificio_3_fechafin}
              pantallasEdificio={facturas.pantallasEdificio}
              edificioId={facturas.edificioId || null}
              pais={pais}
              labelCobrada={pais === "Chile" ? "RECAUDADA" : "COBRADA"}
              onTotalesCalculados={handleTotalesCalculados}
              mostrarFooter={false}
              onDetalle={(sale) => setSelectedSale(sale)}
            />
          ) : activeTab === "variable" && facturas?.listado?.length === 0 ? (
            <p>No hay ventas para este edificio en estas fechas.</p>
          ) : (
            /* CASO "TODOS" O ALIANZA → Tabla de resumen */
            activeTab === "variable" &&
            facturas &&
            facturas.length > 0 &&
            (() => {
              const totalComisionGenerada = facturas.reduce((t, i) => t + i.comisionGenerada, 0);
              return (
                <div>
                  {/* TU TABLA DE TOTALES (la que ya tenías) */}
                  <table className="table table-success table-bordered table-custom table-totales">
                    <thead>
                      <tr className="total-row">
                        <td className="text-start">TOTALES</td>
                        <td className="text-end">
                          {`${moneda(pais)} ${facturas
                            .reduce((total, resumen) => total + resumen.totalFacturado, 0)
                            .toLocaleString(localString(pais), {
                              minimumFractionDigits: decimales(pais),
                              maximumFractionDigits: decimales(pais),
                            })}`}
                        </td>
                        <td className="text-end">
                          {`${moneda(pais)} ${facturas
                            .reduce((total, resumen) => total + resumen.netoFacturado, 0)
                            .toLocaleString(localString(pais), {
                              minimumFractionDigits: decimales(pais),
                              maximumFractionDigits: decimales(pais),
                            })}`}
                        </td>
                        <td className="text-end">
                          {`${moneda(pais)} ${totalComisionGenerada.toLocaleString(localString(pais), {
                            minimumFractionDigits: decimales(pais),
                            maximumFractionDigits: decimales(pais),
                          })}`}
                        </td>
                        <td className="text-center">
                          {facturas
                            .reduce((total, resumen) => {
                              const porcentaje = totalComisionGenerada
                                ? (resumen.comisionGenerada / totalComisionGenerada) * 100
                                : 0;
                              return total + porcentaje;
                            }, 0)
                            .toFixed(0)}
                          %
                        </td>
                      </tr>
                    </thead>
                  </table>

                  <table className="table table-striped table-bordered table-hover table-custom table-detalles">
                    <thead className="text-center align-middle">
                      <tr>
                        <th width="5%">#</th>
                        <th width="25%">EDIFICIO</th>
                        <th width="20%">FACTURACIÓN BRUTA</th>
                        <th width="20%">FACTURACIÓN NETA</th>
                        <th width="20%">COMISIÓN GENERADA</th>
                        <th width="10%">%</th>
                      </tr>
                    </thead>
                    <tbody>
                      {facturas.map((resumen, index) => {
                        const porcentajeComision = totalComisionGenerada
                          ? (resumen.comisionGenerada / totalComisionGenerada) * 100
                          : 0;
                        return (
                          <tr key={resumen.edificio}>
                            <td className="text-center">{index + 1}</td>
                            <td className="text-start uppercase">{resumen.edificio}</td>
                            <td className="text-end">
                              {`${moneda(pais)} ${resumen.totalFacturado.toLocaleString(localString(pais), {
                                minimumFractionDigits: decimales(pais),
                                maximumFractionDigits: decimales(pais),
                              })}`}
                            </td>
                            <td className="text-end">
                              {`${moneda(pais)} ${resumen.netoFacturado.toLocaleString(localString(pais), {
                                minimumFractionDigits: decimales(pais),
                                maximumFractionDigits: decimales(pais),
                              })}`}
                            </td>
                            <td className="text-end">
                              {`${moneda(pais)} ${resumen.comisionGenerada.toLocaleString(localString(pais), {
                                minimumFractionDigits: decimales(pais),
                                maximumFractionDigits: decimales(pais),
                              })}`}
                            </td>
                            <td className="text-center">{porcentajeComision.toFixed(1)}%</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              );
            })()
          )}

          {activeTab === "variable" && facturas && facturas.length === 0 && (
            <p>
              No hay ventas para{" "}
              {edificioSeleccionado === "todos"
                ? "los edificios"
                : todosEdificios.some((ed) => ed.alianza === edificioSeleccionado)
                  ? `la alianza ${edificioSeleccionado}`
                  : "este edificio"}{" "}
              en estas fechas.
            </p>
          )}

          {/* Modal "Detalle cálculo" por venta. El recorte es por CONTEXTO DE VISTA, no por rol:
              estamos mirando un edificio puntual, así que solo ese edificio muestra %/costo de
              comisión (resto "—"). Aplica a todos los roles, incluido superadmin. */}
          {selectedSale && (
            <BuildingDetailsModal
              opportunity={selectedSale}
              buildings={edificiosMapModal}
              clientes={clientes}
              intermediarios={intermediarios}
              pais={pais}
              getRate={getRateModal}
              moneda={moneda(pais).trim()}
              localString={localString(pais)}
              decimales={decimales(pais)}
              edificiosVisibles={facturas?.edificioId != null ? [facturas.edificioId] : null}
              onClose={() => setSelectedSale(null)}
            />
          )}
        </>
      )}
    </div>
  );
};
